import { format } from "date-fns/format";
import { nb } from "date-fns/locale/nb";
import DOMPurify from "dompurify";
import ISirkLogModule from "features/CenterContent/RoleContent/ISirk/ISirkLogModule";
import { IncidentNote } from "features/CenterContent/RoleContent/ISirk/types";
import parse from "html-react-parser";
import { FC } from "react";
import { DropsExpandable, Flex, HStack } from "shared/components/Spor";
import { SectionTitle, Text } from "shared/components/typography/TitleStyles";
import { useTheme } from "styled-components";

const ISirkNote: FC<IncidentNote> = ({
  content,
  summary,
  fromDate,
  toDate,
  isirk,
}) => {
  const theme = useTheme();
  const parsedFromDate = Date.parse(new Date(fromDate).toISOString());
  const parsedToDate = Date.parse(new Date(toDate).toISOString());

  return (
    <DropsExpandable
      title={
        <div>
          <HStack>
            <SectionTitle>{summary}</SectionTitle>
            <Text>{isirk}</Text>
          </HStack>

          <Text>
            {format(parsedFromDate, "dd.MM.yyyy", { locale: nb })} -{" "}
            {format(parsedToDate, "dd.MM.yyyy", { locale: nb })}
          </Text>
        </div>
      }
      collapsible
    >
      <Flex color={theme.colorTextMain} flexDirection="column" p="12px">
        <ISirkLogModule isirk={isirk} />
        {parse(DOMPurify.sanitize(content))}
      </Flex>
    </DropsExpandable>
  );
};

export default ISirkNote;
